<div>
    <form [formGroup]="azureDetailForm" *ngIf="azureDetailForm">
        <div class="w-100">
            <div class="row mt-4 mb-4">
                <div class="col-md-4">
                    <mat-label class="font-style">Issuer Url</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter contact issuer url here"
                            formControlName="issuer_url"
                            (input)="detectValueChange($event)"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-label class="font-style">Instance</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter instance here"
                            formControlName="instance"
                            (input)="detectValueChange($event)"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-label class="font-style">Domain</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter domain here"
                            formControlName="domain"
                            (input)="detectValueChange($event)"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
            </div>

            <div class="row mt-4 mb-4">
                <div class="col-md-4">
                    <mat-label class="font-style">TenantId</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter tenetId here"
                            formControlName="tenetID"
                            (input)="detectValueChange($event)"
                            [readonly]="isEditEnabled === false"
                            [ngClass]="istenetIDShow ? 'pw' : ''"
                        />
                        <i class="fas fa-eye hidenshow" (click)="istenetIDShow = istenetIDShow ? false : true"></i>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-label class="font-style">ClientId</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter clientId here"
                            formControlName="clientID"
                            (input)="detectValueChange($event)"
                            [readonly]="isEditEnabled === false"
                            [ngClass]="isclientIDShow ? 'pw' : ''"
                        />
                        <i class="fas fa-eye hidenshow" (click)="isclientIDShow = isclientIDShow ? false : true"></i>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-label class="font-style">ClientSecret</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter clientSecret here"
                            formControlName="clientSecret"
                            (input)="detectValueChange($event)"
                            [readonly]="isEditEnabled === false"
                            [ngClass]="isclientSecretShow ? 'pw' : ''"
                        />
                        <i class="fas fa-eye hidenshow" (click)="isclientSecretShow = isclientSecretShow ? false : true"></i>
                    </mat-form-field>
                </div>
            </div>

            <div class="row mt-4 mb-4">
                <div class="col-md-4">
                    <mat-label class="font-style">B2CExtensionAppClientId</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter B2CExtensionAppClientId here"
                            formControlName="b2cExtensionAppClientId"
                            (input)="detectValueChange($event)"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-label class="font-style">CallbackPath</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter CallbackPath here"
                            formControlName="callBackPath"
                            (input)="detectValueChange($event)"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-4 d-flex align-items-center">
                    <button type="submit" class="btn btn-dark test-btn" *ngIf="isEditEnabled === true" (click)="testConnection()" [disabled]="isDisableTest">
                        Test Connection
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
